import { ComponentType } from 'react';
import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { AlignTypes } from 'ui/tableHeader';
import { spacing } from 'ui/theme';

import { ExtendedEventInfo } from './types';

export const Cell = styled.div`
  box-sizing: border-box;
  display: table-cell;
  padding: ${spacing.threeQuarter} ${spacing.plusHalf};
`;

export const LeftAlignText = styled.div`
  height: ${spacing.base};
`;

export const RightAlignText = styled.div`
  height: ${spacing.base};
  text-align: right;
  padding-right: ${spacing.quarter};
`;

/**
 * Type props for rowCell function params
 */
interface RowCellProps {
  row: ExtendedEventInfo;
}

type HeaderColumnData = {
  name: string;
  value: string;
  align: AlignTypes;
  RowCell: ComponentType<React.PropsWithChildren<RowCellProps>>;
};

export const TABLE_COLUMNS: HeaderColumnData[] = [
  {
    name: 'Event',
    value: 'eventName',
    align: 'flex-start',
    RowCell: ({ row }: RowCellProps) => {
      return (
        <Cell>
          <LeftAlignText>{row.eventLabel}</LeftAlignText>
        </Cell>
      );
    },
  },
  {
    name: 'Type',
    value: 'eventType',
    align: 'flex-start',
    RowCell: ({ row }: RowCellProps) => {
      return (
        <Cell>
          <LeftAlignText>{row.eventType}</LeftAlignText>
        </Cell>
      );
    },
  },
  {
    name: 'Count',
    value: 'count',
    align: 'flex-start',
    RowCell: ({ row }: RowCellProps) => (
      <Cell>
        <RightAlignText>{row.count}</RightAlignText>
      </Cell>
    ),
  },
  {
    name: 'Percentage',
    value: 'eventPercent',
    align: 'flex-start',
    RowCell: ({ row }: RowCellProps) => (
      <Cell>
        <RightAlignText>{row.eventPercent.toFixed(2)}%</RightAlignText>
      </Cell>
    ),
  },
];

export const LOADING_HEADER_COLUMNS: HeaderColumnData[] = [
  {
    name: 'Event',
    value: 'eventName',
    align: 'flex-start',
    RowCell: () => (
      <Cell>
        <RightAlignText>
          <Skeleton width={300} height={16} />
        </RightAlignText>
      </Cell>
    ),
  },
  {
    name: 'Type',
    value: 'eventType',
    align: 'flex-start',
    RowCell: () => (
      <Cell>
        <RightAlignText>
          <Skeleton width={100} height={16} />
        </RightAlignText>
      </Cell>
    ),
  },
  {
    name: 'Count',
    value: 'count',
    align: 'flex-start',
    RowCell: () => (
      <Cell>
        <RightAlignText>
          <Skeleton width={100} height={16} />
        </RightAlignText>
      </Cell>
    ),
  },
  {
    name: 'Percentage',
    value: 'eventPercent',
    align: 'flex-start',
    RowCell: () => (
      <Cell>
        <RightAlignText>
          <Skeleton width={100} height={16} />
        </RightAlignText>
      </Cell>
    ),
  },
];

export const CSV_EXPORT_HEADERS = [
  {
    label: 'Event',
    key: 'eventName',
  },
  {
    label: 'Type',
    key: 'eventType',
  },
  {
    label: 'Count',
    key: 'count',
  },
  {
    label: 'Percentage (%)',
    key: 'eventPercent',
  },
];

export const LOADING_ROWS = [...Array(10).keys()].map((x) => ({ value: x }));
